import * as actionType from '../actions/actionTypes';
const initialState = {
  methods: [],
  priorities: [],
  statuses: [],
  customParameters: {},
  flightsList: [],
  flightDetails: {},
  createFlightError: ''
}

export default function (state = initialState, action) {
  switch (action.type) {
    case actionType.FLIGHT_METHODS:
      return {
        ...state,
        methods: action.payload,
      }
    case actionType.FLIGHT_PRIORITIES:
      return {
        ...state,
        priorities: action.payload,
      }
    case actionType.FLIGHT_STATUSES:
      return {
        ...state,
        statuses: action.payload,
      }
    case actionType.FLIGHT_CUSTOM_PARAMETERS:
      return {
        ...state,
        customParameters: action.payload,
      }
    case actionType.FLIGHTS_LIST:
      return {
        ...state,
        flightsList: action.payload
      }
    case actionType.FLIGHT_DETAILS:
      return {
        ...state,
        flightDetails: action.payload
      }
    case actionType.CLEAR_FLIGHTS_LIST:
      return {
        ...state,
        flightsList: []
      }
    case actionType.REMOVE_FLIGHT_DETAILS:
      return {
        ...state,
        flightsDetails: {}
      }
    case actionType.CREATE_NEW_FLIGHT_SUCCESS:
      return {
        ...state,
        flightsList: [...state.flightsList, action.payload],
        createFlightError: ''
      }
    case actionType.CREATE_NEW_FLIGHT_FAIL:
      return {
        ...state,
        createFlightError: action.payload
      }
    case actionType.UPDATE_FLIGHT_STATUS_SUCCESS:
      if (state.flightsList.find(flight => flight._id === action.payload._id)) {
        let flightsList = state.flightsList;
        for (var i in flightsList) {
          if (flightsList[i]._id == action.payload._id) {
            flightsList[i].status = action.payload.status;
            break; //Stop this loop, we found it!
          }
        }
        return {
          ...state,
          flightDetails: {
            ...state.flightDetails,
            status: action.payload.status
          },
          flightsList: flightsList
        }
      }
    case actionType.UPDATE_FLIGHT_DETAILS_SUCCESS:
      if (state.flightsList.find(flight => flight._id === action.payload._id)) {
        const filteredArray = state.flightsList.filter(flight => flight._id !== action.payload._id);

        return {
          ...state,
          flightDetails: action.payload,
          flightsList: [action.payload, ...filteredArray]
        }
      }
    default:
      return state;
  }
}

